import { useUserStore } from './modules/user'
import { useRouteStore } from './modules/route'
import { useAiVideoStore } from '@da-vinci/components'

export * from './modules/user'
export { useAiVideoStore }

export const useStore = defineStore('main', () => {
  const user = useUserStore()
  const aiVideo = useAiVideoStore()
  const route = useRouteStore()
  const symbolExport = ref(Symbol('symbolExport'))
  function openAiRecords() {
    symbolExport.value = Symbol('symbolExport')
  }

  const initIng = ref(false)

  return { user, aiVideo, route, openAiRecords, symbolExport, initIng }
})

export const store = createPinia()
